// @vue/component
import { useAllGoalsStore } from "@/stores/WheelAnalysis/allGoals";
import { useCriticalGoalsStore } from "@/stores/WheelAnalysis/criticalGoals";
// import {useGoal11TargetsStore} from "@/stores/WheelAnalysis/goal11Targets";
import { useAdditionalGoalsStore } from "@/stores/WheelAnalysis/additionalGoals";
import { useGoalAStore } from "@/stores/WheelAnalysis/goalA";
import { useGoalBStore } from "@/stores/WheelAnalysis/goalB";
import { useGoalDetailsStore } from "@/stores/WheelAnalysis/goalDetails";
import { storeToRefs } from "pinia";
import { useChallengeStore } from "@/stores/WheelAnalysis/challenge";

export default {
    name: "AllGoals",

    components: {},

    mixins: [],

    props: {},

    setup() {
        const allGoalsStore = useAllGoalsStore();
        const additionalGoalsStore = useAdditionalGoalsStore();
        const challengeStore = useChallengeStore();
        // const goal11TargetsStore = useGoal11TargetsStore()
        const goalAStore = useGoalAStore();
        const goalBStore = useGoalBStore();
        const goalDetailsStore = useGoalDetailsStore();
        const { editMode } = storeToRefs(challengeStore);

        const { selectedGoals } = storeToRefs(allGoalsStore);
        const { selectedTargets } = storeToRefs(allGoalsStore);
        const { currentGoalId } = storeToRefs(goalDetailsStore);

        const criticalGoalsStore = useCriticalGoalsStore();
        const alreadySelectedGoals = criticalGoalsStore.selectedCriticalGoals;

        // --- minimal addition: safe setter to avoid undefined row errors ---
        function setSafeTarget(goalIdx, targetIdx, value) {
            const COLS = 19;
            if (!Array.isArray(allGoalsStore.selectedTargets[goalIdx])) {
                allGoalsStore.selectedTargets[goalIdx] = Array(COLS).fill(false);
            }
            const row = allGoalsStore.selectedTargets[goalIdx].slice();
            row[targetIdx] = value === true || value === "true" || value === 1 || value === "1";
            allGoalsStore.selectedTargets.splice(goalIdx, 1, row); // replace row to trigger reactivity
        }
        // alias so the watcher below observes the same ref
        const checkedTargets = selectedTargets;
        // --- end minimal addition ---

        // merge with critical goals
        if (Array.isArray(criticalGoalsStore.selectedCriticalGoals)) {
            criticalGoalsStore.selectedCriticalGoals.forEach((value, index) => {
                allGoalsStore.selectedGoals[index] = (value == true || value == "true");
            });
        }

        // merge with critical goal targets
        if (Array.isArray(goalAStore.selectedTargets)) {
            goalAStore.selectedTargets.forEach((value, index) => {
                if (criticalGoalsStore.goalAIndex !== null) {
                    setSafeTarget(criticalGoalsStore.goalAIndex, index, value == true || value == "true");
                }
            });
        }
        if (Array.isArray(goalBStore.selectedTargets)) {
            goalBStore.selectedTargets.forEach((value, index) => {
                if (criticalGoalsStore.goalBIndex !== null) {
                    setSafeTarget(criticalGoalsStore.goalBIndex, index, value == true || value == "true");
                }
            });
        }

        // merge with additional goals and targets
        if (Array.isArray(additionalGoalsStore.selectedGoals)) {
            additionalGoalsStore.selectedGoals.forEach((value, index) => {
                if (value == true || value == "true") {
                    allGoalsStore.selectedGoals[index] = true;
                }
            });
        }
        if (Array.isArray(additionalGoalsStore.selectedTargets)) {
            additionalGoalsStore.selectedTargets.forEach((targets, goalIndex) => {
                targets.forEach((value, targetIndex) => {
                    setSafeTarget(goalIndex, targetIndex, value == true || value == "true");
                });
            });
        }

        return {
            allGoalsStore,
            additionalGoalsStore,
            selectedGoals,
            selectedTargets,
            checkedTargets,
            goalDetailsStore,
            editMode,
            criticalGoalsStore,
            alreadySelectedGoals,
            currentGoalId,
            setSafeTarget,
            goalAStore,
            goalBStore,
        };
    },

    computed: {
        // ✅ localized goals+targets array
        goals() {
            return this.$tm("criticalGoals.goals") || [];
        },
    },

    watch: {
        selectedGoals(newCheckedGoals) {
            this.additionalGoalsStore.selectedGoals = newCheckedGoals;
            this.additionalGoalsStore.selectedGoalsChanged();
        },

        "criticalGoalsStore.selectedCriticalGoals": {
            deep: true,
            immediate: true, // run once on mount too
            handler(arr) {
                const next = Array.isArray(arr) ? [...arr] : [];
                // Replace the whole array to ensure Vue notices
                this.allGoalsStore.selectedGoals = next;
            },
        },

        checkedTargets: {
            deep: true,
            handler(newSelectedTargets) {
                console.log(newSelectedTargets);

                // mirror to additional goals
                this.additionalGoalsStore.selectedTargets = this.allGoalsStore.selectedTargets;

                // keep A/B stores in sync if indexes are valid
                const aIdx = this.criticalGoalsStore.goalAIndex;
                if (Number.isInteger(aIdx) && aIdx >= 0) {
                    const rowA = this.allGoalsStore.selectedTargets[aIdx] || [];
                    this.goalAStore.setSelectedTargets
                        ? this.goalAStore.setSelectedTargets(rowA)
                        : (this.goalAStore.selectedTargets = [...rowA]);
                }

                const bIdx = this.criticalGoalsStore.goalBIndex;
                if (Number.isInteger(bIdx) && bIdx >= 0) {
                    const rowB = this.allGoalsStore.selectedTargets[bIdx] || [];
                    this.goalBStore.setSelectedTargets
                        ? this.goalBStore.setSelectedTargets(rowB)
                        : (this.goalBStore.selectedTargets = [...rowB]);
                }

                this.additionalGoalsStore.selectedTargetsChanged();
            },
        },
    },

    created() {},

    methods: {},

    mounted() {
        this.allGoalsStore.fetchWheelAnalysis();
    },
};
